const Password = {

    // PAGE HEADER
    "modem_title": "Change Modem Password",
    "modem_card": "Modem Password",
    "selfcare_title": "Change Self Care Password",
    "selfcare_card": "Self Care Password Details",

    // FIELDS
    "new_password": "New Password",
    "confirm_password": "Confirm Password",
    "selfcare_new_password": "Self Care New Password",
    "selfcare_confirm_password": "Self Care Confirm Password",

    // PLACEHOLDER
    "ph_new_password": "Enter new password",
    "ph_confirm_password": "Enter confirm password",

    // ERROR
    "error_required": "This field is required.",
    "error_mismatch": "Password and confirm password do not match.",

    // TOAST (same text as portal)
    "modem_success": "Modem password has been changed successfully",
    "selfcare_success": "Selfcare password has been changed successfully",

}

export default Password;
